import React from 'react';
import * as style from '../main/article.module.scss';
import {Language} from "../i18n/language";
import {Ellipsis} from "../controls/ellipsis";

export function CerahKidsArticle(props) {
  return (
    <Ellipsis>
      {cerahKidsArticleByLang[Language.activeLangIsoCode]}
    </Ellipsis>
  );
}

const cerahKidsArticleByLang = {
  en: (
    <div className={style.article}>
      <h1>Learn English at Cerah, the Most Convenient English Language School for children.</h1>

      <p>
        In this time of globalization, English language skills are a must for anyone who doesn't want to be left behind.
        Parents need to equip their children with English skills from an early age so that the kids can develop their competences
        to seize big opportunities in the future. However, time limitations usually force parents to choose the nearest English
        school. Now you don't need to be restricted to take your little ones to the nearest school, because we provide online
        English lessons for children with world-class foreign teachers. Get the most effective English lessons and courses,
        with the convenience of having the school at home, and at really affordable prices. An online English course with Cerah
        is the choice of wise parents! You can select the appropriate type of class for your child based on age and level: Kindergarten
        classes (1-5 years old), English tutoring for elementary school students (aged 6-11 years old), or English courses for high
        school and high school students (12 years old and older). No matter how old your child is, whether you live in Singapore,
        the UK, Italy, Spain or elsewhere, English courses online are more practical, more convenient, and better!
      </p>


      <h1>The Advantages and the Fun of Learning English at Cerah.</h1>

      <p>
        There are many reasons to make Cerah your English school of choice for your children learning. Apart from being naturally
        the "nearest" (and cheapest!) English school for your kids, because you don't need to move from home, you get teachers with
        international standards that you could never get at the nearest tuition centre. You can choose between local teachers, foreign
        teachers, or even native teachers. Online English courses for children are limited in the number of students, so the teacher's
        attention is fully devoted to your little ones. Thus, during English lessons, children have plenty of time to always actively
        hone their English conversation skills so that they can progress fast. Our online children's English courses are easy and fun,
        which also helps kids improve quickly, so as to make them become confident and fluent in English conversation. Our classes skip
        tedious theoretical explanations and make children learn the grammar by practice, through the free (but guided) interaction with
        the teacher (in private lessons) and other students (in group courses), through natural conversation. Our specialized teachers
        have lots of experience choosing course materials that are suitable for the students age and interests so that your little one
        has fun while learning English online. The learning process occurs by allowing your children to express the things they like in
        English or by allowing them to speak like their favourite hero using the English language. By making the classes easy and fun,
        children become engaged and interested in learning and their progress is faster, whether they're complete beginners, or they have
        some knowledge of the English language already.
      </p>


      <h1>Our English Courses for Children have Flexible Schedules and you Can Try Them for Free!</h1>

      <p>
        We provide a variety of group class schedules for elementary, middle and high school English courses that you can pick from.
        If you opt for private classes, you can simply choose the time that suits you best for your child's English lessons, with freedom
        to determine how many classes you want in a week. And since you don't need to spend time traveling to the tuition centre, children
        can have more spare time for their hobbies, to play and to rest. All the advantages that our English courses provide can be obtained
        at low prices, and you can take a free trial first for children's English lessons!
      </p>

      <p>
        Develop the great potential in your children and prepare them for their future from now. With our Cerah courses, becoming fluent
        English is an easy goal to achieve, and your children will be prepared to achieve their dreams :-)
      </p>
    </div>
  ),
  id: (
    <div className={style.article}>
      <h1>Belajar Bahasa Inggris di Cerah, Tempat Kursus Bahasa Inggris Anak-Anak Ternyaman.</h1>
      <p>
        Hidup di era globalisasi, kemampuan bahasa Inggris menjadi suatu keharusan bagi setiap orang yang tidak ingin tergilas perkembangan zaman.
        Orang tua perlu membekali anak-anak dengan keahlian bahasa Inggris sejak dini agar si buah hati dapat mengembangkan diri untuk meraih
        kesempatan besar di masa depan. Namun, akibat kesibukan parents yang tiada habisnya, parents harus mencari kursus bahasa Inggris terdekat.
        Parents, kini anda tidak perlu bingung dan repot mengantarkan si kecil, karena kami menyediakan les bahasa Inggris anak online. Les bahasa
        Inggris secara efektif, terdekat dan murah, dibarengi kenyamanan karena tetap berada di rumah. Kursus bahasa Inggris anak online bersama
        kami menjadi andalan para orang tua bijak. Anda dapat memilih sendiri jenis kelas yang sesuai, berdasarkan umur dan tingkatan: Kelas anak
        TK (1-5 tahun), les bahasa Inggris untuk anak SD (usia 6-11 tahun), kursus bahasa Inggris untuk anak SMP dan SMA (12 tahun ke atas). Berapa pun usia
        si kecil, di Jakarta, Bogor, Bandung, Surabaya, Jogjakarta, Medan, Bali, di lokasi mana pun anda berada, kursus bahasa Inggris online jadi jauh lebih
        praktis dan nyaman.
      </p>

      <h1>Keunggulan dan Keseruan Belajar Bahasa Inggris Kids di Cerah.</h1>
      <p>
        Parents, ada seribu alasan untuk menambatkan pilihan pada kami sebagai tempat kursus bahasa Inggris anak anak. Selain merupakan les bahasa Inggris
        anak terdekat dan murah, karena anda hanya berada di rumah, guru-guru kami sangat sabar dan sudah berpengalaman. Kami menyediakan kursus bahasa Inggris
        anak SD, SMP, SMA atau bahkan anak yang baru belajar bicara sekalipun. Anda dapat memilih guru yang anda inginkan, mulai dari guru lokal dan guru asing
        berstandar internasional ataupun native speaker. Kursus bahasa Inggris online untuk anak dibatasi jumlah muridnya, sehingga perhatian pengajar tercurah
        sepenuhnya pada si kecil. Dengan demikian, selama les bahasa Inggris, anak didorong untuk selalu aktif mengasah percakapan bahasa Inggris agar dapat
        menguasai keahlian bahasa Inggris dengan cepat. Kursus bahasa Inggris anak online bersama kami mudah dan cepat, dengan hasil maksimal. Anak jadi percaya
        diri dan fasih dalam percakapan bahasa Inggris. Kami merancang les bahasa Inggris untuk anak secara personal dan terpusat, dimana guru dan murid dapat
        berinteraksi dengan bebas. Guru-guru kami selalu mengupayakan kelas yang menyenangkan agar si kecil betah kursus bahasa Inggris online. Sambil belajar,
        buah hati anda bisa mengekspresikan hal-hal yang ia senangi atau mungkin saja si kecil jadi bisa berbahasa Inggris seperti vlogger favoritnya. Pastinya,
        belajar bahasa Inggris anak anak jadi semakin seru dan mudah. Parents, kami memprioritaskan les bahasa Inggris untuk anak SD, SMP, SMA yang cepat, mudah
        dan menyenangkan. Tentu kalau kelasnya seru, si kecil tidak akan bosan dan makin semangat belajar.
      </p>

      <h1>Kursus Bahasa Inggris Anak dengan Jadwal Fleksibel dan Harga Terjangkau!</h1>
      <p>
        Kami menyediakan kursus bahasa Inggris SD, SMP dan SMA yang bisa anda atur sendiri jadwalnya. Tidak seperti kursus lain yang menentukan jadwal yang tidak
        bisa diganggu gugat, anda bisa memilih waktu terbaik untuk les bahasa Inggris anak. Parents, anda juga bebas menentukan berapa banyak kelas yang diinginkan
        dalam seminggu. Tidak hanya itu, karena tidak perlu menghabiskan waktu perjalanan, anak-anak jadi bisa punya lebih banyak waktu luang untuk melakukan hobi
        dan beristirahat. Semua keuntungan kursus bahasa Inggris anak anak ini bisa didapatkan dengan harga murah. Cerah juga memberikan percobaan pertama gratis
        untuk les bahasa Inggris anak (klik di sini).
      </p>

      <p>Kembangkan potensi besar dalam diri buah hati anda dan persiapkan masa depannya mulai dari sekarang. Bersama Cerah, lancar
        berbahasa Inggris tak lagi mustahil dan si buah hati pun siap melaju meraih impian!</p>
    </div>
  )
}
